import { call, put, select } from 'redux-saga/effects';
import { setProfile } from '../../../effects/organization';
import { completeEnrollment } from '../../../actions/enrollment';

import manageInvites from './manageInvites';
import getOrganizationDetails from '../getOrganizationDetails';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* getProfile() {
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${dpaApiBaseUrl + RESOURCES.V3}/users/me`;
  const { success, error, result } = yield call(callAPI, {
    url,
    method: METHODS.GET,
  });

  if (success && !error) {
    yield put(setProfile({ ...result }));
    if (
      result?.organizations?.length === 0 &&
      result?.pendingInvites?.length === 1
    ) {
      yield call(manageInvites, {
        payload: {
          ...result.pendingInvites[0],
          invitationStatus: 'ACCEPTED',
        },
      });
      yield put(completeEnrollment({ invitedUser: true }));
    } else {
      yield call(getOrganizationDetails);
    }
  } else {
    console.error(error)
  }
}
